import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mk_admin_token", data.access_token);
      localStorage.setItem("mk_admin_email", data.email);
      toast.success("Zalogowano");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Nie udało się zalogować.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] grid place-items-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C534D] hover:text-[#E6007A] transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Powrót na stronę
        </Link>

        <div className="rounded-3xl bg-white border border-[#E8E1D9] p-10 shadow-[0_8px_30px_rgba(230,0,122,0.06)]">
          <div className="font-display text-3xl mb-2">
            mamy<span className="text-[#E6007A]">!</span>kongres
          </div>
          <div className="text-sm text-[#5C534D] mb-8">Panel organizatora</div>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-sm font-semibold mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email"
                className="w-full rounded-xl border border-[#E8E1D9] px-4 py-3 bg-white focus:border-[#E6007A] outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">Hasło</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password"
                className="w-full rounded-xl border border-[#E8E1D9] px-4 py-3 bg-white focus:border-[#E6007A] outline-none"
              />
            </div>
            {error && <div className="text-red-500 text-sm" data-testid="admin-login-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="btn-lift w-full rounded-full bg-[#E6007A] text-white font-semibold py-3 flex items-center justify-center gap-2 disabled:opacity-70"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {loading ? "Loguję..." : "Zaloguj"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
